import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

function EmptyState({
    title = 'No data available',
    description = 'There is nothing to show here yet.',
    actionLabel,
    onAction,
    className,
    ...props
}) {
    return (
        <div className={cn('flex flex-col items-center justify-center py-12', className)} {...props}>
            <h3 className="text-lg font-semibold text-foreground mb-2">{title}</h3>
            <p className="text-sm text-muted-foreground mb-4 max-w-sm text-center">{description}</p>
            {actionLabel && onAction && (
                <Button onClick={onAction}>{actionLabel}</Button>
            )}
        </div>
    );
}

export { EmptyState };
